<template>
  <stquick-card title="Academic Terms">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3">
        <v-icon @click="showD=!showD">add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
       <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
    </template>
    <template v-slot:card-content>
      <v-data-table
        :headers="terms_headers"
        :items="terms"
        class="elevation-0"
        :loading="loading"
        :search="search">
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.work_days}}</td>
          <td class="text-xs-center">
          <v-switch :input-value="setSwitchState(props.item)" :loading="sloading" @change="savesetting(props.item)"></v-switch>
          </td>
          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editterm(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteterm(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Academic Term" :show="showD" pers>
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
          <v-text-field label="Term Name" v-model="term_model.name" :rules="validRules.required"/>
           <v-text-field label="Level" v-model="term_model.level" :rules="validRules.required" type="number" step="1"/>
            <v-text-field label="Work Days" v-model="term_model.work_days" type="number" step="1" :rules="validRules.required"/>
        </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" :loading="loading" @click="saveterm()">save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </stquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal";
export default {
  name: "terms",
  components: {
    "stquick-card": QuickCard,
    "m-dialog": Mdialog
  },
  data() {
    return {
      showD: false,
      pers: false,
      search: "",
      editedIndex: -1,
      sinf_model:{
         active_term:'',
      },
       sinf_modelcp:{
        active_term:'',
      },
      term_model: {
        name: "",
        level:"",
        work_days:""
      },
       term_modelcp: {
        name: "",
        level:"",
        work_days:""
      },
      terms_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Term",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Work Days",
          align: "center",
          sortable: false,
          value: "work_days"
        },
         {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("terms/getAll");

    //console.log("termsooooo",terms)
  },
  computed: {
    ...mapGetters({
      terms: "terms/TERMS",
      terrors: "terms/TERM_ERROR",
      loading: "terms/TERM_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING"
    })
  },
  methods: {
    setSwitchState(val){
      return val.id == this.settings.ayt.term.id ? true:false

    },
    savesetting(term) {
      this.sinf_model.active_term = term
      this.$store.dispatch("settings/add", this.sinf_model);

      if (this.terrors==null) {

         this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Settings saved successfully.",
                title: "Save Settings",
                modal: false
            })
      }else{
        //console.log(terrors)
        this.sinf_model = this.sinf_modelcp;
         this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry settings could not be saved.",
                title: "Save Settings",
                modal: false
            })
      }
    },
    addterm() {
      this.$store.dispatch("terms/add", this.term_model);

      if (this.terrors==null) {
        this.term_model = {};
         this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Term saved successfully.",
                title: "Term",
                modal: false
            })
      }
    },
    deleteterm(term, index) {
      if (confirm("Are you sure you want to delete this term?")) {
        this.$store.dispatch("terms/delete", { term, index });
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Term deleted successfully.",
                title: "Term",
                modal: false
            })
      }
    },

     settermstatus(term) {
      this.editedIndex = this.terms.indexOf(term);
      this.term_model = Object.assign({}, term);
     },

    editterm(term) {
      this.editedIndex = this.terms.indexOf(term);
      this.term_model = Object.assign({}, term);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updateterm(term, index) {
      this.$store.dispatch("terms/update", { index, term });

      if (this.terrors==null) {
        this.term_model = {};
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Term updated successfully.",
                title: "Term",
                modal: false
            })
      }
    },
    saveterm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing term info or saving term info
      if (this.editedIndex > -1) {
        this.updateterm(this.term_model, this.editedIndex);
      } else {
        this.addterm();
      }
    }
  },
  watch:{
    showD(val){
      if(val==false){
        this.term_model = {};
      }
    },

  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/schoolTerms.vue